import * as React from 'react';
export function useFluentProviderContextValues_unstable(state) {
  const {
    root,
    dir,
    targetDocument,
    theme
  } = state;
  const provider = React.useMemo(() => ({
    dir,
    targetDocument
  }), [dir, targetDocument]); // "Tooltip" component mutates an object in this context, instance should be stable

  const [tooltip] = React.useState(() => ({}));
  return {
    provider,
    textDirection: dir,
    tooltip,
    theme,
    themeClassName: root.className
  };
}
//# sourceMappingURL=useFluentProviderContextValues.js.map